"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _stylitas = require("@creditas/stylitas");

var _propTypes = require("prop-types");

var _components = require("./components");

var _core = require("@emotion/core");

const InputWrap = _stylitas.styled.div`
  ${_components.inputWrap};
`;
InputWrap.displayName = 'InputWrap';

const Input = ({
  inputRef,
  inputComponent,
  AdornmentsProps,
  ...inputProps
}) => {
  //eslint-disable-next-line react-hooks/exhaustive-deps
  const InputComponent = _react.default.useCallback((0, _stylitas.styled)(inputComponent)`
      ${_components.inputBase}
    `, [inputComponent]);

  return (0, _core.jsx)(InputWrap, null, (0, _core.jsx)(InputComponent, (0, _extends2.default)({
    ref: inputRef
  }, inputProps)), (0, _core.jsx)(_components.Adornments, (0, _extends2.default)({
    select: inputProps.select,
    multiple: inputProps.multiple,
    success: inputProps.success,
    error: inputProps.error,
    warning: inputProps.warning,
    loading: inputProps.isLoading,
    search: inputProps.search
  }, AdornmentsProps)));
};

exports.Input = Input;
process.env.NODE_ENV !== "production" ? Input.propTypes = {
  inputRef: _propTypes.object,
  inputComponent: (0, _propTypes.oneOfType)([_propTypes.elementType, _propTypes.string]),
  IconComponent: _propTypes.elementType,
  AdornmentsProps: _propTypes.object
} : void 0;
Input.defaultProps = {
  inputComponent: 'input'
};